const levenshteinDistance = (a: string, b: string): number => {
  const matrix: number[][] = Array.from({length: a.length + 1}, () =>
    Array(b.length + 1).fill(0)
  );

  for (let i = 0; i <= a.length; i++) matrix[i][0] = i;
  for (let j = 0; j <= b.length; j++) matrix[0][j] = j;

  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      if (a[i - 1] === b[j - 1]) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] =
          Math.min(
            matrix[i - 1][j], // 삭제
            matrix[i][j - 1], // 삽입
            matrix[i - 1][j - 1] // 교체
          ) + 1;
      }
    }
  }

  return matrix[a.length][b.length];
};

export const findMostSimilarString = (
  target: string,
  strings: string[]
): string | null => {
  if (!Array.isArray(strings) || strings.length === 0) {
    return null;
  }

  let mostSimilar = strings[0];
  let smallestDistance = levenshteinDistance(target, mostSimilar);

  for (const str of strings) {
    const distance = levenshteinDistance(target, str);

    if (distance < smallestDistance) {
      smallestDistance = distance;
      mostSimilar = str;
    }
  }

  return mostSimilar;
};
